<template>
  <transition name="rec">
    <el-dialog
      title="Восстановление пароля"
      :visible="visible"
      :width="isMobile ? '320px' : '526px'"
      custom-class="home-modal"
      @close="$emit('close')"
    >
      <div class="modal-wrapper">
        <div class="recovery">
          Для восстановления пароля обратитесь в отдел поддержки и сопровождения
        </div>
      </div>
    </el-dialog>
  </transition>
</template>

<script>
export default {
  name: 'DialogPasswordRecovery',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="sass" scoped>
.modal-wrapper
  .recovery
    font-size: 18px
</style>
